const page = require('../../../../../components/page/page')
const retailDt = require('./retail-dt')
import retailPage from './retail-page.html'

var HTMLwasSelected = false

function HTMLselect() {
      HTMLwasSelected = true

      const body = document.body
      body.insertAdjacentHTML('beforeend', retailPage)

      retailDt.start({ dest: 'retail', elem: 'dt', act: 'select', entity: 'sale' })
}

export function start(detail) {
      if (!HTMLwasSelected) { HTMLselect() }
      obj[detail.act].start(detail)
}

const obj = {
      show: { start: (detail) => { page.start(detail) } },
}
